import { Box, Stack, Theme, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React from 'react'
import InstagramIcon from '@mui/icons-material/Instagram'
import { FacebookConnectDataElement, InstagramConnectDataElement } from '@3m5/sm_publish-frontend-api'
import ImageComponent from '@professocial/professocialFormComponents/FormComponents/ImageComponent'
import { NetworkType } from '@professocialApi/professocial-core-frontend-api/models'

type IProps = {
  page: FacebookConnectDataElement | InstagramConnectDataElement
  networkType: NetworkType
}

const useStyles = makeStyles((theme: Theme) => ({
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    bottom: 0,
    right: 0,
    height: '24px',
    width: '24px',
    marginRight: theme.spacing(1.2),
    cursor: 'pointer',
    boxShadow: '0px 0px 3px rgba(0, 0, 0, .15)',
    background: 'transparent linear-gradient(199deg, #2343D6 0%, #C1339F 31%, #EE4343 63%, #FDAA36 100%) 0% 0% no-repeat padding-box',
    borderRadius: '50%',
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: '1.1rem',
  },
  img: {
    borderRadius: '50%',
    height: '54px',
    width: '54px',
    margin: '0 13px 0 0',
  },
}))

const AvatarSet: React.FC<IProps> = (props) => {
  const classes = useStyles()

  const instagramPage: InstagramConnectDataElement = props.page as InstagramConnectDataElement
  const networkUserName = instagramPage.page.networkUserName
  return (
    <Stack direction='row' alignItems='center'>
      <Box sx={{ position: 'relative' }}>
        <ImageComponent className={classes.img} src={`https://graph.facebook.com/${props.page.page.networkPageId}/picture`} fallback='/src/shared/assets/images/defaultFacebookProfileImage.jpg' />
        {props.networkType === NetworkType.Instagram && (
          <Box className={classes.iconContainer}><InstagramIcon className={classes.icon} /></Box>
        )}
      </Box>
      <Stack>
        <>
          {props.networkType === NetworkType.Facebook &&
            <Typography variant='h4'>{props.page.page.pageName}</Typography>}
          {props.networkType === NetworkType.Instagram &&
            <Typography variant='h4'>{networkUserName}</Typography>}
        </>
        {/* {props.page.page.pageStatistics?.fanCount && <Typography sx={{ lineHeight: 1.235 }}>{`${props.page.page.pageStatistics?.fanCount} Fans`}</Typography>} */}
      </Stack>
    </Stack>
  )
}

export default AvatarSet
